import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

import {
    DEFAULT_INSIGHTS_WINDOW,
    INSIGHTS_WINDOW_SCHEMA,
} from '@apps/web/components/metrics/insights/insights_window_picker';
import { MetricsPage } from '@apps/web/components/metrics/metrics_page';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import { useUser } from '@apps/web/swr_data_fetching/current_user_queries';
import { useOrganization } from '@apps/web/swr_data_fetching/organization_queries';

export const Route = createFileRoute('/_app/(main)/metrics')({
    component: MetricsRoute,
    head: () => ({
        meta: [
            {
                title: 'Metrics | Phoebe',
            },
        ],
    }),
    validateSearch: z.object({
        insights_window: INSIGHTS_WINDOW_SCHEMA.optional().catch(
            DEFAULT_INSIGHTS_WINDOW,
        ),
    }),
});

function MetricsRoute() {
    const organizationId = useOrganizationId();
    const { data: user } = useUser({
        reason: 'metrics-route-guard',
    });
    const { data: organization } = useOrganization(organizationId, {
        reason: 'metrics-route-guard',
    });
    const navigate = useNavigate();
    const canView = !!(
        user &&
        organization &&
        (user.admin || organization.features?.metrics_enabled)
    );

    useEffect(() => {
        if (user && organization && !canView) {
            navigate({ to: '/', replace: true });
        }
    }, [user, organization, canView, navigate]);

    if (user && organization && !canView) {
        return null;
    }

    return <MetricsPage />;
}
